module.exports = __webpack_public_path__ + "components/country-flag/static/tv-fd2caae1fd2cb51b675a3189221b978c.svg";